import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import { red } from '@material-ui/core/colors';
import intrestedinprogram from './intrestedinprogram';


const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};
const mystyle = {
    paddingTop: "20px",
    paddingBottom: "20px",
    marginLeft: "15px",
    marginRight: "15px",
};
class Machinelearningpy extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">    <Link href=""><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active" aria-current="page">Certificate Course in Machine Learning using Python</li>
                    </ol>
                </div>
                <section class="course-header power-color" id="course-header">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg">
                            <h1>Certificate Course in Machine Learning using Python<br /></h1>
                            <p><br />Accelerate your Career. Stay Ahead of the Curve </p><br />  <br />
                            <br />
                            <div class="form-group">
                                <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>  <br />  <br />
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">

                            <p>Jointly Delivered by eduplusnow and Industry Expert</p>
                            <br />
                            <table class="table-highlight">
                                <tr>
                                    <td> <img alt="executive2" width="" src="/assets/images/epn.svg" /></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </section>
                <div class="course-main-contains def-z">
                    <div class="card" id="Description">
                        <div class="row contanint-display">
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;80 hours <br />
                                    <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;80 hours<br />
                                    <i class="fa fa-tasks" ></i> &nbsp;&nbsp; WEEKEND BATCH</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" >
                                <b><i class=" fa fa-calendar-o" ></i> &nbsp;&nbsp;&nbsp;WEEKDAY&nbsp; (MON - FRI)<br />
                                    <i class=" fa fa-calendar-o" ></i> &nbsp;&nbsp;&nbsp;WEEKEND&nbsp; (SAT - SUN)</b>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="def-z">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Industry">Industry Trends</a></li>
                            <li><a href="#tools">Tools</a></li>
                            <li><a href="#syllabus">Syllabus</a></li>
                            <li><a href="#Outcomes">Learning Outcomes</a></li>
                            <li><a href="#Review">Learner Review</a></li>
                            <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>
                        </ul>
                    </div>
                </section>
                <section class="course-description " id="course-description">
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>About Machine Learning using Python</h3>
                            <p align="justify">Machine Learning is the study of computer algorithms that improve automatically throught experience. It is an application of artificial intelligence  .</p>
                        </div>
                    </div>
                    <br />
                    <div class="row" >
                        <div class="col-sm-12">
                            <h4>Course Features</h4>
                            <p align="justify">Eduplusnow's Machine Learning course offers an in depth coverage of Machine Learning topics , developing algorithms using supervised & unsupervised learning, regression, classification and time series modeling using Python.</p>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12" >
                            <h4> Who Should Enroll? </h4>
                            <p align="justify" id="Industry">Ideal For Analytics Managers, Business Analytst, Data Analyst, Developers Looking To Become Data Scientist And Graduates Seeking A Career In Data Sceince And Machine Learning.</p>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12" >
                            <h4 >Eligibility </h4>
                            <p align="justify">Prerequisites For Machine Learning Course Is Understanding Of Basic Statistics , Familiarity With Python Programming Is Also Benificial.</p>
                        </div>
                    </div>
                </section>
                <section class="course-industry-trends bg-secondary" id="course-industry-trends">
                    <div class="row">
                        <div class=" col-md-6 col-sm-12">
                            <h3> Industry Trends </h3>
                            <br />
                            <h5>Job Roles</h5>
                            <ul class="industry-trends-ul">
                                <li> Machine learning Engineer</li>
                                <li> Software Developer / Engineer (AI/ML)</li>
                                <li id="tools"> Data Scientist</li>
                            </ul>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <img alt="datascience11" src="/assets/images/icons/industry-trends.svg" />
                        </div>
                    </div>
                </section>
                <br />
                <section class="course-tools-covered" id="course-tools-covered" >
                    <h3 > Tools Covered </h3>
                    <br />
                    <Carousel swipeable={true}
                        draggable={true}
                        showDots={false}
                        arrows={false}
                        responsive={responsive}
                        ssr={true} // means to render carousel on server-side.
                        infinite={true}
                        autoPlay={this.props.deviceType !== "mobile" ? true : false}
                        autoPlaySpeed={1000}
                        keyBoardControl={true}
                        customTransition="all .5"
                        transitionDuration={2000}
                        containerClass="carousel-container"
                        removeArrowOnDeviceType={["tablet", "mobile"]}
                        deviceType={this.props.deviceType}
                        dotListClass="custom-dot-list-style">
                        <div class="item">
                            <div class="card" style={mystyle} >
                                <center id="syllabus"><img alt="datascience11" src="/assets/images/icons/Ipython.jpg" height="100" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center><img alt="datascience11" src="/assets/images/icons/Jupyter_logo.jpg" height="100" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center><img alt="datascience11" src="/assets/images/icons/matlib.jpeg" height="100" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center><img alt="datascience11" src="/assets/images/icons/python-pandas.png" height="100" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center><img alt="datascience11" src="/assets/images/icons/Numpy.png" height="100" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center><img alt="datascience11" src="/assets/images/icons/Scikit_learn.jpg" height="100" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center><img alt="datascience11" src="/assets/images/icons/seaborn.jfif" height="100" /> </center>
                            </div>
                        </div>
                    </Carousel>
                </section>
                <section class="course-syllabus" id="course-syllabus">
                    <h3> Syllabus </h3>
                    <br />
                    <div class="row" >
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                            <div class="syl-bg">
                                <h5>Machine Learning in Python </h5>
                                <div id="de_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Machine Learning
                                 </h6>
                                            </div>
                                            <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Applying Business Intelligence via Statistical Modeling </li>
                                                        <li> Types of Machine Learning  </li>
                                                        <li> Supervised Learning </li>
                                                        <li> Classification </li>
                                                        <li> Regression </li>
                                                        <li> Unsupervised Learning </li>
                                                        <li> Clustering </li>
                                                        <li> Dimensionality Reduction </li>
                                                    </ul>
                                                    <hr />
                                                    <ul class="syllabus-ul">
                                                        <b>Phases of Machine Learning Project </b>
                                                        <li>Data Collection </li>
                                                        <li>Data Visualization </li>
                                                        <li>Data Preprocessing </li>
                                                        <li>Data Modeling </li>
                                                        <li>Deployment </li>
                                                        <li>Maintenance </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Machine Learning Ecosystem in Python
                                 </h6>
                                            </div>
                                            <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Python Overview </li>
                                                        <li> IPython </li>
                                                        <li> Jupyter Notebook </li>
                                                        <li> Matplotlib & Seaborn for Data Visualization </li>
                                                        <li> Pandas & Numpy for Data Preprocessing & Cleanup </li>
                                                        <li> Scikit-learn for Machine Learning Modeling </li>
                                                        <li> Understanding End-to-End Small Machine Learning Project </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i>Matplotlib & Seaborn for Data Visualization
                                 </h6>
                                            </div>
                                            <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Need for Data Visualization </li>
                                                        <li> Draw plots using seaborn for gaining data insights </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i>Pandas for Data Preprocessing & Cleanup
                                 </h6>
                                            </div>
                                            <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Doing Data Scaling, Fill Missing Values using Pandas </li>
                                                        <li> Using Numpy </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                                href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i>Scikit-learn for Machine Learning Model Creation
                                 </h6>
                                            </div>
                                            <div id="de_syllabus5" class="collapse show" aria-labelledby="de_heading5"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Choosing machine learning algorithm for modeling </li>
                                                        <li> Model Evaluation </li>
                                                        <li> Improving accuracy by feature engineering </li>
                                                        <li> Hyper-Parameter Fine Tuning to improve accuracy </li>
                                                        <li> Avoiding Over fitting </li>
                                                        <li> Understanding metrics of Model Evaluation </li>
                                                        <li> Trying different models & creating final ensemble model </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading6" data-toggle="collapse"
                                                href="#de_syllabus6" aria-expanded="true" aria-controls="de_syllabus6">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i>Doing End-to-End Machine Learning Project Demo
                                 </h6>
                                            </div>
                                            <div id="de_syllabus6" class="collapse show" aria-labelledby="de_heading6"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Classification </li>
                                                        <li> Regression </li>
                                                        <li> Clustering </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading7" data-toggle="collapse"
                                                href="#de_syllabus7" aria-expanded="true" aria-controls="de_syllabus7">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i>Machine Learning Algorithms
                                 </h6>
                                            </div>
                                            <div id="de_syllabus7" class="collapse show" aria-labelledby="de_heading7"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Algorithms Overview & Comparison </li>
                                                        <li> Different trade-offs while deciding the final ML Model </li>
                                                        <li> Bias-Variance Tradeoff </li>
                                                        <li id="Outcomes"> Model Complexity vs Model Interpretability </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading8" data-toggle="collapse"
                                                href="#de_syllabus8" aria-expanded="true" aria-controls="de_syllabus8">
                                                <h6 class="panel-title" >
                                                    <i class="indicator fa fa-minus"></i> Practical Project Development
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>Learning Outcomes</h3>
                            <ul class="lo-ul">
                                <li>Eduplusnow's Machine Learning using python  program will make you an expert in Machine learning algorithms. In this course you will learn  techniques how to work with python and how to use various machine learning algorithms.
                           </li>
                            </ul>
                            <br />
                            <h5>Assessment </h5>
                            <p align="justify" id="Review">
                                Periodic assessment and case studies evaluations by the edu plus now and Industry Expert have been built in throughout the duration of the course.
                        </p>
                        </div>
                        <div class="col-sm-6">
                            <img alt="datascience18" src="/assets/images/icons/certificate1.png" />
                            <p class="img-below-text text-center">Awarded by edu plus now
                        </p>
                        </div>
                    </div>
                </section>
                <Aboutuslearners />
                <Aluminicompany />
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                            </div>
                            <div class="vertical-line-fee"> </div>
                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br /><br />
                                        <h5>Features</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li>In depth coverage of Machine Learning topics.</li>
                                            <li>Developing algorithms using supervised and unsupervised learning.</li>
                                            <li>Regression analysis.</li>
                                            <li>Classification and time series modeling using Python.</li>
                                        </ul>
                                    </div>
                                    <p align="justify" class="font-text-alumni" ><span style={{ color: red }}>*</span>Alumni of Eduplusnow, VIT, VIIT, VU Will Get Special Discount, To Grab your Discount coupon Please Contact  &nbsp; <a href="tel://8956167195" class="contact-us-mobile"> <i class="fa fa-phone icon-tick"> </i>+918956167195. </a><br /></p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
            <div class="row">
            <div class="col-sm-12">
            <h3>
            About the Organization
            </h3>
            <br />
            <img alt="datascience23"width="200px" src="/assets/images/eduplusnow.png" />
            <br /><br />
            <p align="justify">edu plus now is an online educational platform that was launched in 2019 to bridge the skill gap between classroom learning, real business challenges and to help students achieve their career potential.
            </p>
            <br />
            <p align="justify">Aimed at providing learners with essential technical skills, edu plus now courses are created to be the perfect amalgamation of inputs from industry experts and highly-qualified professors from the country’s top educational institutions. This allows individuals and companies to close the skill gap quickly, innovate faster and achieve their key objectives. At edu plus now, we believe in preparing students for success in a changing world by providing online courses that pave the path for a successful career. Built under the aegis of the Vishwakarma Group, the online education platform provides flexible learning that fits a learner’s schedule. 
            </p>
            </div>
            </div>
            </section>
            </div>
        );
    }
}

export default Machinelearningpy;